import Resources from "shared/actions/resourcesActions";

// eslint-disable-next-line import/prefer-default-export
export class WebhooksResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "webhook", `/api/v1/webhooks`);
  }
}
